"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorType = exports.InputCheckbox = exports.InputTypeRequired = exports.plusOneProductOptions = exports.UrlInputNames = exports.InputName = exports.InputIds = exports.InputType = void 0;
var InputType;
(function (InputType) {
    InputType["INPUT"] = "input";
    InputType["TEXTAREA"] = "textarea";
    InputType["SELECT"] = "select";
    InputType["CHECKBOX"] = "checkbox";
})(InputType || (exports.InputType = InputType = {}));
var InputIds;
(function (InputIds) {
    InputIds["EMAIL"] = "plusOneEmail";
    InputIds["SUBJECT"] = "plusOneSubject";
    InputIds["PRODUCT"] = "plusOneProduct";
    InputIds["EID"] = "plusOneEid";
    InputIds["DESCRIPTION"] = "plusOneDescription";
    InputIds["CHECKBOX"] = "plusOneCheckbox";
})(InputIds || (exports.InputIds = InputIds = {}));
var InputName;
(function (InputName) {
    InputName["EMAIL"] = "Email";
    InputName["SUBJECT"] = "Subject";
    InputName["PRODUCT"] = "Product";
    InputName["EID"] = "EID";
    InputName["DESCRIPTION"] = "Description";
    InputName["CHECKBOX"] = "UserConsent";
})(InputName || (exports.InputName = InputName = {}));
var UrlInputNames;
(function (UrlInputNames) {
    UrlInputNames["Email"] = "plus1_email";
    UrlInputNames["Product"] = "plus1_product";
    UrlInputNames["Subject"] = "plus1_subject";
    UrlInputNames["EID"] = "plus1_eid";
    UrlInputNames["Description"] = "plus1_description";
})(UrlInputNames || (exports.UrlInputNames = UrlInputNames = {}));
exports.plusOneProductOptions = {
    software: {
        title: 'PLUS+1 Software',
        value: 'software',
        hidden: false,
    },
    connect: {
        title: 'PLUS+1 Connect',
        value: 'connect',
        hidden: false,
    },
    guideTraining: {
        title: 'PLUS+1 GUIDE Training',
        value: 'guideTraining',
        hidden: false,
    },
    hardware: {
        title: 'PLUS+1 Hardware',
        value: 'hardware',
        hidden: false,
    },
    marketplace: {
        title: 'PLUS+1 Marketplace',
        value: 'marketplace',
        hidden: false,
    },
    radioRemoteControl: {
        title: 'PLUS+1 Remote Controls (RCT)',
        value: 'radioRemoteControl',
        hidden: false,
    },
    autonomy: {
        title: 'PLUS+1 Autonomy',
        value: 'autonomy',
        hidden: false,
    },
    guide: {
        title: 'PLUS+1 GUIDE',
        value: 'guide',
        hidden: true,
    },
    service: {
        title: 'PLUS+1 Service Tool',
        value: 'service',
        hidden: true,
    },
    mobilesev: {
        title: 'PLUS+1 Mobile Service Tool',
        value: 'mobilesev',
        hidden: true,
    },
    updatec: {
        title: 'PLUS+1 Update Center',
        value: 'updatec',
        hidden: true,
    },
    license: {
        title: 'PLUS+1 License',
        value: 'license',
        hidden: true,
    },
    dip: {
        title: 'MyDanfoss Account',
        value: 'dip',
        hidden: true,
    },
};
var InputTypeRequired;
(function (InputTypeRequired) {
    InputTypeRequired[InputTypeRequired["TRUE"] = 1] = "TRUE";
    InputTypeRequired[InputTypeRequired["FALSE"] = 0] = "FALSE";
})(InputTypeRequired || (exports.InputTypeRequired = InputTypeRequired = {}));
var InputCheckbox;
(function (InputCheckbox) {
    InputCheckbox["TRUE"] = "true";
    InputCheckbox["FALSE"] = "false";
})(InputCheckbox || (exports.InputCheckbox = InputCheckbox = {}));
var ErrorType;
(function (ErrorType) {
    ErrorType["validationError"] = "Front-end validation error";
    ErrorType["serverError"] = "Back-end error";
})(ErrorType || (exports.ErrorType = ErrorType = {}));
